import "./GanttTimeline.css";

import { JSX } from "react/jsx-runtime";

import { GanttTick, GanttTimelineProps } from "../../models";

const TickRow = ({ ticks, height }: { ticks: GanttTick[]; height: number }): JSX.Element => (
  <div className="GanttTickRow" style={{ height }}>
    {ticks.map((tick) => (
      <div
        key={`${tick.x}-${tick.label}`}
        className={`GanttTick${tick.isHighlighted ? " GanttTickHighlighted" : ""}`}
        style={{ left: tick.x, width: tick.width }}
        title={tick.label}
      >
        <span className="body4 GanttTickLabel">{tick.label}</span>
      </div>
    ))}
  </div>
);

export const GanttTimeline = ({ ticks, timelineWidth, todayX, showToday }: GanttTimelineProps): JSX.Element => (
  <div className="GanttTimeline" style={{ width: timelineWidth }}>
    <TickRow ticks={ticks.topRow} height={24} />
    <TickRow ticks={ticks.bottomRow} height={24} />
    {showToday && (
      <div className="GanttTodayMarker" style={{ left: todayX }}>
        <span className="body4 GanttTodayLabel">Today</span>
      </div>
    )}
  </div>
);
